/**
 * Product: load Gropulse reviews after LCP from product.reviews.json
 * so the widget CSS is not in the main PDP head.
 */
(function () {
  var host = document.querySelector('[data-lazy-apps="true"]');
  if (!host) return;

  var loaded = false;
  function load() {
    if (loaded) return;
    loaded = true;

    var params = new URLSearchParams(window.location.search);
    params.set('view', 'reviews');
    params.delete('section_id');
    var url = window.location.pathname + '?' + params.toString();

    fetch(url)
      .then(function (res) {
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var anchor = doc.querySelector('#product-anchor-reviews');
        var incoming =
          (anchor && anchor.closest('.shopify-section')) ||
          doc.querySelector('[id*="__reviews"]') ||
          doc.querySelector('.shopify-section');
        var current = host.closest('.shopify-section');
        if (!incoming || !current) return;

        incoming
          .querySelectorAll('link[href*="fonts.googleapis"], link[href*="fonts.gstatic"]')
          .forEach(function (link) {
            link.remove();
          });

        doc.querySelectorAll('link[href*="three-column-style-one"], link[href*="gropulse"]').forEach(function (link) {
          if (/fonts\.googleapis|fonts\.gstatic/i.test(link.href)) return;
          if (document.querySelector('link[href="' + link.href + '"]')) return;
          var copy = document.createElement('link');
          copy.rel = 'stylesheet';
          copy.href = link.href;
          copy.media = 'all';
          document.head.appendChild(copy);
        });

        var scripts = Array.prototype.slice.call(incoming.querySelectorAll('script')).filter(function (old) {
          var type = (old.getAttribute('type') || 'text/javascript').toLowerCase();
          return type === 'text/javascript' || type === 'application/javascript' || type === 'module' || type === '';
        });
        current.innerHTML = incoming.innerHTML;
        scripts.forEach(function (old) {
          var script = document.createElement('script');
          if (old.type) script.type = old.type;
          if (old.src) {
            script.src = old.src;
            script.defer = true;
          } else {
            script.textContent = old.textContent;
          }
          document.body.appendChild(script);
        });
      })
      .catch(function () {
        loaded = false;
      });
  }

  function afterLcp() {
    if (window.requestIdleCallback) {
      requestIdleCallback(load, { timeout: 2500 });
    } else {
      setTimeout(load, 400);
    }
  }

  if (typeof PerformanceObserver === 'undefined') {
    setTimeout(afterLcp, 4000);
    return;
  }

  try {
    var finished = false;
    var po = new PerformanceObserver(function (list) {
      if (!list.getEntries().length) return;
      finished = true;
      try {
        po.disconnect();
      } catch (e) {
        /* ignore */
      }
      afterLcp();
    });
    po.observe({ type: 'largest-contentful-paint', buffered: true });
    setTimeout(function () {
      if (!finished) afterLcp();
    }, 5000);
  } catch (e) {
    setTimeout(afterLcp, 4000);
  }
})();
